import { 
  doc, 
  getDoc
} from 'firebase/firestore';
import { db } from '../firebase/config';

// Generic function 
export const getSectionData = async (collectionName, docId = null) => {
  try {
    const docName = docId || collectionName; 
    const docRef = doc(db, collectionName, docName);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      console.warn(`Document ${docName} not found in collection ${collectionName}`);
      return null;
    }
  } catch (error) {
    console.error(`Error getting ${collectionName}:`, error);
    throw error;
  }
};